import React, { useState, useRef, useEffect } from 'react';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddressbookLabel from '#component/addressbook/dashboard/addressbook-label';
import AddressbookActions from '#component/addressbook/dashboard/addressbook-actions';
import WarehouseActions from '#component/warehouse/site-manager/warehouse-actions/warehouse-actions';
import { RootSection, StyledAccordionDetails, addressbookLabelStyles } from './styles';

/**
 * Renders Mui Accordion with empty addressbooks.
 * @returns {React.FC}
 */

const EmptyAddressBooks = props => {
  const { emptyData, caller = 'site' } = props;
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [elementForMenu, setElementForMenu] = useState({});
  const theme = useTheme();
  const rootEl = useRef(null);
  const timeoutId = useRef(null);

  const isAddressBook = caller === 'address book';

  useEffect(() => () => {
    clearTimeout(timeoutId.current);
  }, []);

  const handleElementClick = ab => event => {
    setElementForMenu(ab);
    setAnchorEl1(event.currentTarget);
  };

  const handleAccordionChange = (event, expanded) => {
    if (expanded) {
      timeoutId.current = setTimeout(() => {
        const y = rootEl?.current?.offsetTop;
        if (y) {
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }
      }, 500);
    }
  };

  const labelStyle = addressbookLabelStyles(theme);

  const mapElements = el => (
    <AddressbookLabel
      key={el.id}
      tooltip={`${caller} actions`}
      style={labelStyle}
      addressbookLabel={el.label}
      projectTitle={el.project?.title}
      onClick={handleElementClick(el)}
    />);

  if (!emptyData?.length) {
    return null;
  }

  return (
    <RootSection ref={rootEl}>
      <Accordion defaultExpanded={!isAddressBook} onChange={handleAccordionChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>
            {`Empty ${caller}s`}
          </Typography>
        </AccordionSummary>
        <StyledAccordionDetails>
          {emptyData?.map(mapElements)}
        </StyledAccordionDetails>
      </Accordion>
      {emptyData?.length > 0 && (
        isAddressBook ?
          <AddressbookActions
            anchorEl={anchorEl1}
            setAnchorEl={setAnchorEl1}
            addressbook={elementForMenu}
          /> :
          <WarehouseActions
            anchorEl={anchorEl1}
            setAnchorEl={setAnchorEl1}
            warehouse={elementForMenu}
          />)}
    </RootSection>
  );
};

export default EmptyAddressBooks;
